const app = Stimulus.Application.start();
app.register("vehicles", class extends Stimulus.Controller {
    static values = {
        page: Number,
        filterEcu: String,
        filterBrand: String
    }

    static get targets() {
        return ['list', 'brandSelector', 'ecuSelector', 'methodSelector', 'typeSelector', 'searchInput', 'brandDropdown', 'ecuDropdown', 'methodDropdown', 'typeDropdown'];
    }

    connect() {
        this.pageValue = 1;
        this.timer = null;
        this.abortController = null;
        if (!this.hasListTarget) {
            this.alternateListTarget = document.getElementById('ecu-list');
        }
        this.currentLocale = (typeof window.Shopify !== 'undefined') ? window.Shopify.locale : 'en';

        // Bind click events for searchable select options
        this.element.querySelectorAll('.searchable-select__options').forEach(list => {
            list.addEventListener('click', this.selectOption.bind(this));
        });

        // Close dropdowns when clicking outside
        this._closeDropdownsBound = this.closeDropdowns.bind(this);
        document.addEventListener('click', this._closeDropdownsBound);

        this.loadVehicles();
    }

    disconnect() {
        document.removeEventListener('click', this._closeDropdownsBound);
    }

    searchVehicles(e) {
        const query = this.hasSearchInputTarget ? this.searchInputTarget.value : '';
        const selector = this.hasTypeSelectorTarget ? this.typeSelectorTarget.value : '';

        this.pageValue = 1;

        // debounce the search : wait 400ms before sending the request
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.loadVehicles(query, selector);
        }, 400);
    }


    loadPage(e) {
        const page = e.target.dataset.vehiclesPageValue;
        const query = this.searchInputTarget.value || '';
        const selector = this.typeSelectorTarget.value || '';

        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.pageValue = page;
            this.loadVehicles(query, selector);
        }, 200);
    }

    loadVehicles(query = '', selector = '') {
        if (this.abortController) {
            this.abortController.abort();
        }
        this.abortController = new AbortController();

        const url = this.builSearchUrl(query, selector);
        fetch(url,
            {
                method: 'GET',
                headers: {
                    'content-type': 'application/json'
                },
                signal: this.abortController.signal,
            }
        )
            .then(response => response.json())
            .then(data => {
                if (data.data.length === 0) {
                    console.log('no results found');
                    // display no results found
                    this.listTarget.innerHTML = document.getElementById('empty-list').innerHTML;
                    // clear pagination
                    document.querySelector('.pagination').innerHTML = '';
                    return;
                }

                if (this.hasListTarget) {
                    this.listTarget.innerHTML = '';
                } else {
                    this.alternateListTarget.innerHTML = '';
                }
                data.data.forEach(item => this.populateItemTemplate(item))
                this.populatePagination(data);
                setTimeout(() => {
                    if (this.hasListTarget) {

                        this.listTarget.childNodes.forEach(node => {
                            node.style.opacity = 1;
                        })
                    } else {
                        this.alternateListTarget.childNodes.forEach(node => {
                            node.style.opacity = 1;
                        })
                    }
                }, 50)
            })
            .catch(error => {
                if (error.name === 'AbortError') return;
                console.error(error);
                this.listTarget.innerHTML = document.getElementById('empty-list').innerHTML;
                document.querySelector('.pagination').innerHTML = '';
            })
    }

    toggleDropdown(e) {
        const wrapper = e.currentTarget.closest('.searchable-select');
        const isOpen = wrapper.classList.contains('is-open');

        // Close all dropdowns first
        this.element.querySelectorAll('.searchable-select.is-open').forEach(el => {
            el.classList.remove('is-open');
        });

        if (!isOpen) {
            wrapper.classList.add('is-open');
            const searchInput = wrapper.querySelector('.searchable-select__search');
            if (searchInput) {
                searchInput.value = '';
                searchInput.focus();
                // Reset filter
                wrapper.querySelectorAll('.searchable-select__options li').forEach(li => {
                    const displayStyle = li.dataset.displayStyle ?? '';
                    li.style.display = displayStyle;
                });
            }
        }
    }

    filterOptions(e) {
        const query = e.currentTarget.value.toLowerCase();
        const wrapper = e.currentTarget.closest('.searchable-select');
        const items = wrapper.querySelectorAll('.searchable-select__options li');

        items.forEach(li => {
            const text = li.textContent.toLowerCase();
            const hiddenByType = li.dataset.displayStyle === 'none';
            li.style.display = (!hiddenByType && text.includes(query)) ? '' : 'none';
        });
    }

    selectOption(e) {
        const li = e.target.closest('li');
        if (!li) return;

        const wrapper = li.closest('.searchable-select');
        const value = li.dataset.value;
        const label = li.textContent;

        // Update hidden input value
        const hiddenInput = wrapper.querySelector('input[type="hidden"]');
        hiddenInput.value = value;

        // Update trigger label
        const triggerLabel = wrapper.querySelector('.searchable-select__label');
        triggerLabel.textContent = label;
        wrapper.classList.toggle('has-value', value !== '');

        // Close dropdown
        wrapper.classList.remove('is-open');

        // If the type dropdown was changed, filter manufacturer options
        if (this.hasTypeDropdownTarget && wrapper === this.typeDropdownTarget) {
            this.filterBrandsByType(value);
        }

        // Trigger search
        this.searchVehicles();
    }

    resetOption(target) {
        // Update hidden input value
        const hiddenInput = target.querySelector('input[type="hidden"]');
        hiddenInput.value = '';

        // Update trigger label
        const triggerLabel = target.querySelector('.searchable-select__label');
        const triggerInput = target.querySelector('.searchable-select__search');
        triggerLabel.textContent = triggerInput.placeholder;
        target.classList.toggle('has-value','');
    }

    filterBrandsByType(selectedType) {
        if (!this.hasBrandDropdownTarget) return;

        const brandItems = this.brandDropdownTarget.querySelectorAll('.searchable-select__options li');

        brandItems.forEach(li => {
            const carType = li.dataset.carType;
            // Always show the "All" option (no data-value) and items matching the selected type
            if (!selectedType || !li.dataset.value || !carType || carType === selectedType) {
                li.dataset.displayStyle = '';
            } else {
                li.dataset.displayStyle = 'none';
                if(li.dataset.value === this.brandSelectorTarget.value) {
                    this.resetOption(this.brandDropdownTarget)
                }
            }
        });
    }

    closeDropdowns(e) {
        if (!e.target.closest('.searchable-select')) {
            this.element.querySelectorAll('.searchable-select.is-open').forEach(el => {
                el.classList.remove('is-open');
            });
        }
    }

    controlUnitFilter(e) {
        this.searchVehicles();
    }

    populateItemTemplate(itemData) {
        const template = document.getElementById('ecu-list-element').innerHTML;

        let populatedTemplate =
            template.replace('**manuf**', itemData.manufacturer)
                .replace('**logo**', `https://assets.autotuner.com/brand/logo/${itemData.manufacturerId}.png`)
                .replace('**modelVersionYear**', `${itemData.model} ${itemData.version ?? ''} ${itemData.from}`)
                .replace('**engine**', `${itemData.engine} ${itemData.power}Hp/${itemData.torque}Nm`)
                .replace('**ecu**', `<span>${itemData.ecuManufacturer} ${itemData.ecu}</span> <small>${itemData.mcu}</small>`)
                // to lower case and replace spaces with dashes and delete special characters .replace(/[^a-zA-Z0-9-]/g, '')
                .replace('**ecu-url**', this.getECUUrl(itemData.ecuManufacturer, itemData.ecu, itemData.mcu))
                .replace('**methods**', itemData.methods.map(method =>
                    `<li class="icon ${method.replace(/ /g, '-')}">
                                <a title="${method}" href="${this.buildMethodLink(method)}" target="_blank">
                                    <span>${method}</span>
                                </a>
                            </li>`).join(''))
                .replace('**ecu-type**', itemData.ecuType === 'engine' ? 'ECU' : itemData.ecuType === 'gearbox' ? 'TCU' : itemData.ecuType)
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = populatedTemplate.trim();
        // tempDiv.firstChild.style.opacity = 0;
        // tempDiv.firstChild.style.transition = 'opacity 0.5s';
        if (this.hasListTarget) {
            this.listTarget.appendChild(tempDiv.firstChild)
        } else {
            this.alternateListTarget.appendChild(tempDiv.firstChild)
        }
    }

    buildMethodLink(method) {
        // add the current locale to the method link if different from en
        if (this.currentLocale === 'en') {
            return `/pages/flash-method/${method.replace(/_/g, '-')}`;
        }
        if (this.currentLocale === 'pt-PT' || this.currentLocale === 'pt-BR') {
            return `/pt/pages/flash-method/${method.replace(/_/g, '-')}`;
        }
        return `/${this.currentLocale}/pages/flash-method/${method.replace(/_/g, '-')}`;
    }


    populatePagination(data) {
        const pagination = document.querySelector('.pagination');
        pagination.innerHTML = '';
        // create a button for the fist page
        const startPage = (this.pageValue > 5) ? this.pageValue - 5 : 1;
        let endPage = (this.pageValue > 5) ? this.pageValue + 5 : 10;
        if (endPage > data.nbPage) {
            endPage = data.nbPage;
        }
        if (startPage > 1) {
            pagination.appendChild(this.createButton('first', 1));
        }

        for (let i = startPage; i <= endPage; i++) {
            const button = this.createButton(i, i);
            if (i === this.pageValue) {
                button.classList.add('active')
            }
            pagination.appendChild(button);
        }
        if (endPage < data.nbPage) {
            pagination.appendChild(this.createButton('last', data.nbPage));
        }

    }

    createButton(text, page) {
        const button = document.createElement('button');
        button.classList.add('btn');
        button.dataset.vehiclesPageValue = page;
        button.textContent = text;
        button.addEventListener('click', this.loadPage.bind(this));
        return button;
    }

    builSearchUrl(query, selector) {
        let searchQuery = '';
        const encodedQuery = encodeURIComponent(query).replace(/%20/g, '+');
        searchQuery = `search=${encodedQuery}`;
        if (selector.toLowerCase() === 'truck') {
            selector = 'trucks';
        }
        if (selector.toLowerCase() === 'tractor') {
            selector = 'agri';
        }
        const encodedSelector = encodeURIComponent(selector);
        searchQuery = `${searchQuery}&type=${encodedSelector}`;

        const controlUnitFilter = document.querySelector('input[name="controlUnit"]:checked')?.value;
        let ecuType = '';
        if (controlUnitFilter !== null) {
            if (controlUnitFilter === 'ECU') {
                ecuType = 'engine';
            } else if (controlUnitFilter === 'TCU') {
                ecuType = 'gearbox';
            } else {
                ecuType = '';
            }
            ecuType = encodeURIComponent(ecuType);
            ecuType = ecuType.replace(/%20/g, '+');
            searchQuery = `${searchQuery}&ecuType=${ecuType}`;
        }

        if (window.currentEcuId) {
            let ecuId = encodeURIComponent(window.currentEcuId);
            ecuId = ecuId.replace(/%20/g, '+');
            searchQuery = `${searchQuery}&ecuId=${ecuId}`;
        } else if(this.ecuSelectorTarget.value) {
            let ecus = encodeURIComponent(this.ecuSelectorTarget.value);
            ecus = ecus.replace(/%20/g, '+');
            searchQuery = `${searchQuery}&ecu=${ecus}`;
        } else if(this.filterEcuValue) {
            let ecus = encodeURIComponent(this.filterEcuValue);
            ecus = ecus.replace(/%20/g, '+');
            searchQuery = `${searchQuery}&ecu=${ecus}`;
        }

        if (window.currentManufacturer) {
            let manufacturer = encodeURIComponent(window.currentManufacturer);
            manufacturer = manufacturer.replace(/%20/g, '+');
            manufacturer = manufacturer.toLowerCase();
            searchQuery = `${searchQuery}&brand=${manufacturer}`;
        } else if(this.brandSelectorTarget.value) {
            let brands = encodeURIComponent(this.brandSelectorTarget.value);
            brands = brands.replace(/%20/g, '+');
            searchQuery = `${searchQuery}&brand=${brands}`;
        } else if(this.filterBrandValue) {
            let brands = encodeURIComponent(this.filterBrandValue);
            brands = brands.replace(/%20/g, '+');
            searchQuery = `${searchQuery}&brand=${brands}`;
        }

        if (window.currentMethod) {
            let method = encodeURIComponent(window.currentMethod);
            method = method.replace(/%20/g, '+');
            method = method.toLowerCase();
            searchQuery = `${searchQuery}&method=${method}`;
        } else if(this.methodSelectorTarget.value) {
            let methods = encodeURIComponent(this.methodSelectorTarget.value);
            methods = methods.replace(/%20/g, '+');
            searchQuery = `${searchQuery}&method=${methods}`;
        } else if(this.filterMethodValue) {
            let methods = encodeURIComponent(this.filterMethodValue);
            methods = methods.replace(/%20/g, '+');
            searchQuery = `${searchQuery}&method=${methods}`;
        }

        if (window.forAtOne) {
            searchQuery = `${searchQuery}&atOne=true`;
        }
        return `${window.searchEndpoint}/search/page/${this.pageValue}?${searchQuery.replace('%2B', '+')}`;
    }


    getECUUrl(ecuManufacturer, ecu, mcu) {
        let url = '/pages/ecu/' + `${ecuManufacturer}-${ecu.replace(/[^a-zA-Z0-9-]/g, '')}-${mcu.replace(/[^a-zA-Z0-9-]/g, '')}`
            .toLowerCase().replace(/ /g, '-')
            // remmove trailing dashes if any
            .replace(/-+$/g, '')
        ;

        if (this.currentLocale === 'en') {
            return url
        }
        if (this.currentLocale === 'pt-PT' || this.currentLocale === 'pt-BR') {
            return `/pt${url}`
        }
        url = `/${this.currentLocale}${url}`;
        fetch(url, {
            method: 'HEAD',
            //mode: "no-cors"
        })
            .then(res => {
                if (res.ok) {
                    return url;
                } else {
                    // fallback to english version
                    return window.location.href+'/#';
                }
            })
            .catch(err => {

                return window.location.href+'/#';
            });
        return url;
        // return `/${this.currentLocale}${url}`
    }

    formatFilter(filterValue) {
        console.log(filterValue);
        const result = filterValue.replace("*", "")
            .replaceAll("and ", "")
            .replaceAll(", ", ";");
        console.log(result);
        return result;
    }
})